import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges
} from '@angular/core';
import {
	Pagination
} from '../types';


const Constants = {
	RECORDSPERPAGE: 10,
};

@Component({
	selector: 'app-pagination-two',
	templateUrl: './pagination-two.component.html',
	styleUrls: ['./pagination-two.component.css']
})
export class PaginationTwoComponent implements OnInit, OnChanges {
	@Input() count: number;
	@Input() defaultRecordsPerPage: number;
	@Output() pageNumber: EventEmitter < number > = new EventEmitter < number > ();
	@Output() recordsPerPage: EventEmitter < number > = new EventEmitter < number > ();
	@Input() pagination: Pagination;
	@Input() pageDetails: any;
	pages: number[] = [];
	perpage = 10;
	pageNumLocal;
	paginationCtrls = {
		next: false,
		prev: false,
		last: false,
		first: false
	};
	activePageIndex = 0;

	constructor() {}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.count || changes.pageDetails['itemsPerPage'] || changes.pageDetails['pageNo']) {
			this.perpage = this.pageDetails['itemsPerPage'];
			this.createPagination();
		}

	}
	ngOnInit() {
		this.perpage = this.pageDetails['itemsPerPage'];
	}

	get shouldVisible() {
		return this.count >= 10;
	}
	createPagination() {
		this.pages.length = 0;
		// debugger
		this.pageNumLocal = Math.ceil(this.count / this.pageDetails['itemsPerPage']);
		for (let i = this.pageDetails['pageNo']; i <= this.pageNumLocal; i++) {
			this.pages.push(i);
		}
	}

	sendPageNo(i) {
		this.pageNumber.emit(i);
		console.log(this.activePageIndex);
		this.createPagination();
	}

	goToLastPage() {
		if (this.pageDetails['pageNo'] !== this.pageNumLocal) {
			this.pageNumber.emit(this.pageNumLocal);
			this.createPagination();
		} else {
			return;
		}
	}

	sendPerPage() {
		this.recordsPerPage.emit(this.perpage);
		this.pageNumber.emit(1);
		this.createPagination();
	}

	goToFirstPage() {
		if (this.pageDetails['pageNo'] !== 1) {
			this.pageNumber.emit(1);
			this.createPagination();
		} else {
			return;
		}
	}

	goToNextPage() {
		if (this.pageDetails['pageNo'] !== this.pageNumLocal) {
			this.pageNumber.emit(this.pageDetails['pageNo'] * 1 + 1 * 1);
			this.createPagination();
		} else {
			return;
		}
	}

	goToPreviousPage() {
		if (this.pageDetails['pageNo'] !== 1) {
			this.pageNumber.emit((this.pageDetails['pageNo'] * 1) - (1 * 1));
			this.createPagination();
		} else {
			return;
		}
	}

}
